export default __webpack_public_path__ + "static/media/trusted_shipping_usp_v2.f8cc6654.svg";